<template>
  <main class="p-4">
    <div class="mt-2" />
    <p>In order to play in a Private League, you should have received a communication from your league commissioner with your League ID Number and League Password.</p>
    <p>If you have not received your communication, please contact your league commissioner.</p>
    <ims-input type="text" placeholder="League ID Number" v-model="id" />
    <ims-input type="password" placeholder="League Password" required v-model="password" />
    <ims-button type="solid" color="primary" size="lg" class="btn-block my-3">Join Private League</ims-button>
  </main>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      password: ""
    };
  }
};
</script>